/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { ClimateRelatedMetrics } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ClimateRelatedMetricsIndustryMetricsUpdateForm(props) {
  const {
    id: idProp,
    climateRelatedMetrics: climateRelatedMetricsModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    MetricDataSetName: "",
    IndustryCode: "",
    DisclosureCode: "",
    DisclosureTopic: "",
    MetricCode: "",
    Metric: "",
    MetricValue: "",
    MetricUnitOfMeasure: "",
    DiscussionAnalysis: "",
  };
  const [MetricDataSetName, setMetricDataSetName] = React.useState(
    initialValues.MetricDataSetName
  );
  const [IndustryCode, setIndustryCode] = React.useState(
    initialValues.IndustryCode
  );
  const [DisclosureCode, setDisclosureCode] = React.useState(
    initialValues.DisclosureCode
  );
  const [DisclosureTopic, setDisclosureTopic] = React.useState(
    initialValues.DisclosureTopic
  );
  const [MetricCode, setMetricCode] = React.useState(initialValues.MetricCode);
  const [Metric, setMetric] = React.useState(initialValues.Metric);
  const [MetricValue, setMetricValue] = React.useState(
    initialValues.MetricValue
  );
  const [MetricUnitOfMeasure, setMetricUnitOfMeasure] = React.useState(
    initialValues.MetricUnitOfMeasure
  );
  const [DiscussionAnalysis, setDiscussionAnalysis] = React.useState(
    initialValues.DiscussionAnalysis
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = climateRelatedMetricsRecord
      ? { ...initialValues, ...climateRelatedMetricsRecord }
      : initialValues;
    setMetricDataSetName(cleanValues.MetricDataSetName);
    setIndustryCode(cleanValues.IndustryCode);
    setDisclosureCode(cleanValues.DisclosureCode);
    setDisclosureTopic(cleanValues.DisclosureTopic);
    setMetricCode(cleanValues.MetricCode);
    setMetric(cleanValues.Metric);
    setMetricValue(cleanValues.MetricValue);
    setMetricUnitOfMeasure(cleanValues.MetricUnitOfMeasure);
    setDiscussionAnalysis(cleanValues.DiscussionAnalysis);
    setErrors({});
  };
  const [climateRelatedMetricsRecord, setClimateRelatedMetricsRecord] =
    React.useState(climateRelatedMetricsModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(ClimateRelatedMetrics, idProp)
        : climateRelatedMetricsModelProp;
      setClimateRelatedMetricsRecord(record);
    };
    queryData();
  }, [idProp, climateRelatedMetricsModelProp]);
  React.useEffect(resetStateValues, [climateRelatedMetricsRecord]);
  const validations = {
    MetricDataSetName: [],
    IndustryCode: [],
    DisclosureCode: [],
    DisclosureTopic: [],
    MetricCode: [],
    Metric: [],
    MetricValue: [],
    MetricUnitOfMeasure: [],
    DiscussionAnalysis: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          MetricDataSetName,
          IndustryCode,
          DisclosureCode,
          DisclosureTopic,
          MetricCode,
          Metric,
          MetricValue,
          MetricUnitOfMeasure,
          DiscussionAnalysis,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            ClimateRelatedMetrics.copyOf(
              climateRelatedMetricsRecord,
              (updated) => {
                Object.assign(updated, modelFields);
              }
            )
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(
        overrides,
        "ClimateRelatedMetricsIndustryMetricsUpdateForm"
      )}
      {...rest}
    >
      <Heading
        level={4}
        children="Climate Related Metrics - Industry-based Metric"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="IFRS S2 paragraph 32."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Heading>
      <Text
        children="Update this record describing an industry-based metric associated with one or more particular business models, activities or other common features that characterise participation in your industry."
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <TextField
        label="Industry-based metric record name"
        isRequired={false}
        isReadOnly={false}
        value={MetricDataSetName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              MetricDataSetName: value,
              IndustryCode,
              DisclosureCode,
              DisclosureTopic,
              MetricCode,
              Metric,
              MetricValue,
              MetricUnitOfMeasure,
              DiscussionAnalysis,
            };
            const result = onChange(modelFields);
            value = result?.MetricDataSetName ?? value;
          }
          if (errors.MetricDataSetName?.hasError) {
            runValidationTasks("MetricDataSetName", value);
          }
          setMetricDataSetName(value);
        }}
        onBlur={() =>
          runValidationTasks("MetricDataSetName", MetricDataSetName)
        }
        errorMessage={errors.MetricDataSetName?.errorMessage}
        hasError={errors.MetricDataSetName?.hasError}
        {...getOverrideProps(overrides, "MetricDataSetName")}
      ></TextField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Divider>
      <TextField
        label="Industry code"
        isRequired={false}
        isReadOnly={false}
        value={IndustryCode}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              MetricDataSetName,
              IndustryCode: value,
              DisclosureCode,
              DisclosureTopic,
              MetricCode,
              Metric,
              MetricValue,
              MetricUnitOfMeasure,
              DiscussionAnalysis,
            };
            const result = onChange(modelFields);
            value = result?.IndustryCode ?? value;
          }
          if (errors.IndustryCode?.hasError) {
            runValidationTasks("IndustryCode", value);
          }
          setIndustryCode(value);
        }}
        onBlur={() => runValidationTasks("IndustryCode", IndustryCode)}
        errorMessage={errors.IndustryCode?.errorMessage}
        hasError={errors.IndustryCode?.hasError}
        {...getOverrideProps(overrides, "IndustryCode")}
      ></TextField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid7")}
      >
        <TextField
          label="Disclosure code"
          isRequired={false}
          isReadOnly={false}
          value={DisclosureCode}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                MetricDataSetName,
                IndustryCode,
                DisclosureCode: value,
                DisclosureTopic,
                MetricCode,
                Metric,
                MetricValue,
                MetricUnitOfMeasure,
                DiscussionAnalysis,
              };
              const result = onChange(modelFields);
              value = result?.DisclosureCode ?? value;
            }
            if (errors.DisclosureCode?.hasError) {
              runValidationTasks("DisclosureCode", value);
            }
            setDisclosureCode(value);
          }}
          onBlur={() => runValidationTasks("DisclosureCode", DisclosureCode)}
          errorMessage={errors.DisclosureCode?.errorMessage}
          hasError={errors.DisclosureCode?.hasError}
          {...getOverrideProps(overrides, "DisclosureCode")}
        ></TextField>
        <TextField
          label="Disclosure topic"
          isRequired={false}
          isReadOnly={false}
          value={DisclosureTopic}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                MetricDataSetName,
                IndustryCode,
                DisclosureCode,
                DisclosureTopic: value,
                MetricCode,
                Metric,
                MetricValue,
                MetricUnitOfMeasure,
                DiscussionAnalysis,
              };
              const result = onChange(modelFields);
              value = result?.DisclosureTopic ?? value;
            }
            if (errors.DisclosureTopic?.hasError) {
              runValidationTasks("DisclosureTopic", value);
            }
            setDisclosureTopic(value);
          }}
          onBlur={() => runValidationTasks("DisclosureTopic", DisclosureTopic)}
          errorMessage={errors.DisclosureTopic?.errorMessage}
          hasError={errors.DisclosureTopic?.hasError}
          {...getOverrideProps(overrides, "DisclosureTopic")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid8")}
      >
        <TextField
          label="Metric code"
          isRequired={false}
          isReadOnly={false}
          value={MetricCode}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                MetricDataSetName,
                IndustryCode,
                DisclosureCode,
                DisclosureTopic,
                MetricCode: value,
                Metric,
                MetricValue,
                MetricUnitOfMeasure,
                DiscussionAnalysis,
              };
              const result = onChange(modelFields);
              value = result?.MetricCode ?? value;
            }
            if (errors.MetricCode?.hasError) {
              runValidationTasks("MetricCode", value);
            }
            setMetricCode(value);
          }}
          onBlur={() => runValidationTasks("MetricCode", MetricCode)}
          errorMessage={errors.MetricCode?.errorMessage}
          hasError={errors.MetricCode?.hasError}
          {...getOverrideProps(overrides, "MetricCode")}
        ></TextField>
        <TextField
          label="Metric"
          isRequired={false}
          isReadOnly={false}
          value={Metric}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                MetricDataSetName,
                IndustryCode,
                DisclosureCode,
                DisclosureTopic,
                MetricCode,
                Metric: value,
                MetricValue,
                MetricUnitOfMeasure,
                DiscussionAnalysis,
              };
              const result = onChange(modelFields);
              value = result?.Metric ?? value;
            }
            if (errors.Metric?.hasError) {
              runValidationTasks("Metric", value);
            }
            setMetric(value);
          }}
          onBlur={() => runValidationTasks("Metric", Metric)}
          errorMessage={errors.Metric?.errorMessage}
          hasError={errors.Metric?.hasError}
          {...getOverrideProps(overrides, "Metric")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid9")}
      >
        <TextField
          label="Metric value"
          isRequired={false}
          isReadOnly={false}
          value={MetricValue}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                MetricDataSetName,
                IndustryCode,
                DisclosureCode,
                DisclosureTopic,
                MetricCode,
                Metric,
                MetricValue: value,
                MetricUnitOfMeasure,
                DiscussionAnalysis,
              };
              const result = onChange(modelFields);
              value = result?.MetricValue ?? value;
            }
            if (errors.MetricValue?.hasError) {
              runValidationTasks("MetricValue", value);
            }
            setMetricValue(value);
          }}
          onBlur={() => runValidationTasks("MetricValue", MetricValue)}
          errorMessage={errors.MetricValue?.errorMessage}
          hasError={errors.MetricValue?.hasError}
          {...getOverrideProps(overrides, "MetricValue")}
        ></TextField>
        <TextField
          label="Metric unit of measure"
          isRequired={false}
          isReadOnly={false}
          value={MetricUnitOfMeasure}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                MetricDataSetName,
                IndustryCode,
                DisclosureCode,
                DisclosureTopic,
                MetricCode,
                Metric,
                MetricValue,
                MetricUnitOfMeasure: value,
                DiscussionAnalysis,
              };
              const result = onChange(modelFields);
              value = result?.MetricUnitOfMeasure ?? value;
            }
            if (errors.MetricUnitOfMeasure?.hasError) {
              runValidationTasks("MetricUnitOfMeasure", value);
            }
            setMetricUnitOfMeasure(value);
          }}
          onBlur={() =>
            runValidationTasks("MetricUnitOfMeasure", MetricUnitOfMeasure)
          }
          errorMessage={errors.MetricUnitOfMeasure?.errorMessage}
          hasError={errors.MetricUnitOfMeasure?.hasError}
          {...getOverrideProps(overrides, "MetricUnitOfMeasure")}
        ></TextField>
      </Grid>
      <TextAreaField
        label="Discussion analysis"
        isRequired={false}
        isReadOnly={false}
        value={DiscussionAnalysis}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              MetricDataSetName,
              IndustryCode,
              DisclosureCode,
              DisclosureTopic,
              MetricCode,
              Metric,
              MetricValue,
              MetricUnitOfMeasure,
              DiscussionAnalysis: value,
            };
            const result = onChange(modelFields);
            value = result?.DiscussionAnalysis ?? value;
          }
          if (errors.DiscussionAnalysis?.hasError) {
            runValidationTasks("DiscussionAnalysis", value);
          }
          setDiscussionAnalysis(value);
        }}
        onBlur={() =>
          runValidationTasks("DiscussionAnalysis", DiscussionAnalysis)
        }
        errorMessage={errors.DiscussionAnalysis?.errorMessage}
        hasError={errors.DiscussionAnalysis?.hasError}
        {...getOverrideProps(overrides, "DiscussionAnalysis")}
      ></TextAreaField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || climateRelatedMetricsModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || climateRelatedMetricsModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
